import React from "react";
import {
    ArrowLeft,
    ArrowRight,
    Bell,
    Copy,
    Check,
    ChevronRight,
    Clock3,
    Eye,
    EyeOff,
    Globe2,
    Grid2X2,
    Heart,
    House,
    LogIn,
    LogOut,
    MapPin,
    Menu,
    Minus,
    Moon,
    Navigation,
    Package,
    Phone,
    Plus,
    ReceiptText,
    RefreshCcw,
    Search,
    Settings,
    ShoppingBag,
    ShoppingCart,
    Sun,
    Tag,
    Truck,
    UserPlus,
    UserRound,
    X,
    type LucideIcon,
} from "lucide-react";
import "./icon.css";

export type IconName =
    | "arrow-left"
    | "arrow-right"
    | "bag"
    | "bell"
    | "cart"
    | "check"
    | "chevron-right"
    | "clock"
    | "eye"
    | "eye-off"
    | "globe"
    | "grid"
    | "heart"
    | "home"
    | "log-in"
    | "log-out"
    | "map-pin"
    | "menu"
    | "minus"
    | "moon"
    | "navigation"
    | "package"
    | "phone"
    | "plus"
    | "receipt"
    | "refresh"
    | "search"
    | "settings"
    | "sun"
    | "tag"
    | "truck"
    | "user"
    | "user-plus"
    | "x"
    | "copy";

const icons: Record<IconName, LucideIcon> = {
    "arrow-left": ArrowLeft,
    "arrow-right": ArrowRight,
    "bag": ShoppingBag,
    "bell": Bell,
    "cart": ShoppingCart,
    "check": Check,
    "chevron-right": ChevronRight,
    "clock": Clock3,
    "eye": Eye,
    "eye-off": EyeOff,
    "globe": Globe2,
    "grid": Grid2X2,
    "heart": Heart,
    "home": House,
    "log-in": LogIn,
    "log-out": LogOut,
    "map-pin": MapPin,
    "menu": Menu,
    "minus": Minus,
    "moon": Moon,
    "navigation": Navigation,
    "package": Package,
    "phone": Phone,
    "plus": Plus,
    "receipt": ReceiptText,
    "refresh": RefreshCcw,
    "search": Search,
    "settings": Settings,
    "sun": Sun,
    "tag": Tag,
    "truck": Truck,
    "user": UserRound,
    "user-plus": UserPlus,
    "x": X,
    "copy": Copy,
};

export function Icon({ name, size = "md" }: { name: IconName; size?: "sm" | "md" | "lg" }) {
    const IconComponent = icons[name];
    const sizeClass = size === "md" ? "" : ` ${size}`;
    return <IconComponent className={`icon icon-${name}${sizeClass}`} aria-hidden="true" focusable="false" strokeWidth={2} />;
}
